export const commonConstants = {
  SET_SEND_EMAIL_STATES: "SET_SEND_EMAIL_STATES",
};
